import { useState, useEffect } from 'react';
import { _basename } from '../../Globals';

const RagnaLoader = props => {
    const [ellipsis, setEllipsis] = useState("");

    useEffect(_ => {
        setEllipsis("");
    }, []);

    useEffect(_ => {
        var time = 1000;
        setTimeout(_ => {
            if (ellipsis.length >= 3) setEllipsis("");
            else setEllipsis(e => e + ".");
        }, time);
    }, [ellipsis]);

    return <div style={{ gap: 5 }} className="justify-content-center d-flex align-items-center">
        <img width="30" src={_basename + (props.Poring?"ragna-":"")+"loader.gif"} alt="loader image" /> {props.text ?? "Loading data"}{ellipsis}
    </div>
}

export default RagnaLoader;